// source: design/src/pages/IoTRobotPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-robot.png',
  heroTitle: '机器人',
  pageTitle: '机器人解决方案',
  heroSubtitle: 'Robotics Solutions',
  heroTagline: '融合IoT物联网与机器人技术，开启企业自动化新纪元',
  corporatePartnerships: {
    title: '飞狼聚联科技（上海）有限公司是云深处科技正式授权A级代理商',
    link: {
      label: '云深处科技官网',
      path: 'https://www.deeprobotics.cn/robot',
    },
  },
  intro: [
    '机器人正在从“未来技术”逐渐走进真实的工作现场。',
    '在工厂，它们可以代替人完成高频巡检；在仓储与物流现场，它们可以承担搬运与运输；在高温、高空、狭窄或其他危险环境中，它们也开始成为人类可靠的工作伙伴。随着 IoT、AI 与机器人技术不断融合，机器人所承担的已经不只是简单的重复劳动，而是越来越多过去需要依赖人工完成的复杂任务。',
    '中国机器人产业正在快速发展，以云深处科技的工业巡检机器人为代表，国产机器人在性能、应用能力与成本方面已经具备较强的国际竞争力。',
    '飞狼与云深处科技合作，将机器人技术与企业实际业务场景结合，从机器人选型、IoT连接、系统集成到现场实施与运维，为企业构建真正能够投入使用的机器人解决方案。我们希望做的不只是“把机器人带进企业”，而是让机器人真正成为企业运营的一部分。',
  ],
  scenarioTitle: '行业应用场景',
  scenarioTitleEn: 'Use Cases',
  scenarios: [
    {
      image: 'si/images/iot-scene-factory.png',
      title: '工厂巡检',
      desc: '四足机器人搭载热成像与气体传感器，24小时自动执行设备巡检任务，发现异常实时报警。适用场景：电力配电房、化工厂区、数据中心。',
    },
    {
      image: 'si/images/iot-scene-warehouse.png',
      title: '仓储物流',
      desc: 'AGV/AMR自动搬运、分拣、码垛，与WMS系统联动实现仓储作业全流程自动化。',
    },
    {
      image: 'si/images/iot-scene-hazard.png',
      title: '危险环境作业',
      desc: '机器人替代人员进入有毒、高温、辐射等危险环境执行检测与采样任务。',
    },
    {
      image: 'si/images/iot-scene-construction.png',
      title: '建筑工地监测',
      desc: '无人机与地面机器人协同，实现施工进度监控、安全巡查、土方量测量。',
    },
    {
      image: 'si/images/iot-scene-security.png',
      title: '安防巡逻',
      desc: '自主巡逻机器人搭载高清摄像与夜视设备，实现园区、仓库、厂区的智能安防。',
    },
    {
      image: 'si/images/iot-scene-remote.png',
      title: '远程运维',
      desc: '通过5G网络实现机器人远程操控与实时数据传输，专家远程指导现场作业。',
    },
  ],
  matrixTitle: '产品矩阵',
  matrixTitleEn: 'Product Matrix',
  matrixHeadings: {
    type: '产品类型',
    mobility: '移动方式',
    payload: '负载能力',
    conn: '通信方式',
    usage: '主要应用',
  },
  matrixRows: [
    {
      type: '四足机器人',
      mobility: '高机动',
      payload: '中等',
      conn: '5G / WiFi',
      usage: '巡检、搜救',
    },
    {
      type: '轮式AMR',
      mobility: '中速',
      payload: '高',
      conn: 'WiFi / BLE',
      usage: '物流搬运',
    },
    {
      type: '协作机械臂',
      mobility: '固定',
      payload: '可变',
      conn: 'OPC-UA / ROS',
      usage: '装配作业',
    },
    {
      type: '无人机(UAV)',
      mobility: '飞行',
      payload: '轻量',
      conn: '4G / 5G',
      usage: '空中巡检',
    },
  ],
  note: '注：飞狼作为解决方案集成商，不直接生产机器人硬件。我们基于Deep Robotics Lite3/X30等市场领先产品，为客户提供定制化的机器人系统集成服务。',
};
